import { NonTripOfferSelectionCard } from '@/components/manage/refund/non-trip-offer/NonTripOfferSelectionCard';
import { toggleRefundNonTripAdmission } from '@/features/manage/manageActions';
import {
  manageFlowBookingSelector,
  manageFlowTravelAccountsMapSelector,
  refundSelectedNonTripAdmissionsSelector,
} from '@/features/manage/manageSelectors';
import { useSeparateNonTripOffersBasedOnType } from '@/hooks/useSeparateNonTripOffersBasedOnType';
import { useDispatch, useSelector } from '@/store/utils';
import { useMemo, type FC } from 'react';

interface RefundNonTripSelectionProps {}

export const RefundNonTripSelection: FC<RefundNonTripSelectionProps> = () => {
  const dispatch = useDispatch();
  const selectedNonTripAdmissions = useSelector(
    refundSelectedNonTripAdmissionsSelector
  );
  const booking = useSelector(manageFlowBookingSelector);
  const travelAccountsMap = useSelector(manageFlowTravelAccountsMapSelector);
  const { travelPass, multiRide } = useSeparateNonTripOffersBasedOnType(
    booking?.nonTripOffers,
    travelAccountsMap
  );
  const nonTripOffers = useMemo(
    () =>
      [...travelPass, ...multiRide].filter(
        (nonTripOffer) => nonTripOffer.status !== 'REFUNDED'
      ),
    [multiRide, travelPass]
  );

  return (
    <div className="flex flex-col gap-3 p-4">
      {nonTripOffers.map((nonTripOffer) => (
        <NonTripOfferSelectionCard
          key={nonTripOffer.id}
          nonTripOffer={nonTripOffer}
          isSelected={Boolean(
            nonTripOffer.id && selectedNonTripAdmissions[nonTripOffer.id]
          )}
          onSelect={() => {
            dispatch(
              toggleRefundNonTripAdmission({
                ...nonTripOffer,
                hasBeenInSoldStatus: false, //Parameter for agent-tool, does not concern the webshop. Kert asked me to ignore it.
              })
            );
          }}
        />
      ))}
    </div>
  );
};
